import { render, staticRenderFns } from "./BlogShow.vue?vue&type=template&id=44d4e1dd&scoped=true&"
import script from "./BlogShow.vue?vue&type=script&lang=js&"
export * from "./BlogShow.vue?vue&type=script&lang=js&"
import style0 from "./BlogShow.vue?vue&type=style&index=0&id=44d4e1dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d4e1dd",
  null
  
)

export default component.exports